import { ApiResponseStatusUnauthorized, ApiResponseSuccess } from "utils/Constant";

export const checkRole = (user_role = "", role = "") => {
   const userRole = user_role?.toLowerCase();
   return userRole === role
}

export const RoundTwoDecimals = (number = 0) => {
   return Math.round(number);
};

export const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
export const decimal = num => num.toString().replace(/[^0-9.]/g, "");

export const money = event => {
   return (addCommas(removeNonNumeric(event)))
}

export const addSpaceEvery4 = (value) =>
  value.replace(/\s+/g, '').replace(/(.{4})/g, '$1 ').trim();


export const GetStatus = e => {
   let status = ""

   if (e === "1"){
      status = "Active"
   }else if(e === "2"){
      status = "Deleted"
   }else if(e === "3"){
      status = "Pending"
   }else if(e === "4"){
      status = ""
   }else{
      status = ""
   }

   return status
}

export const GetPaymentStatus = e => {
   let status = ""

   if (e === "1"){
      status = "On Process"
   }else if(e === "2"){
      status = "Completed"
   }else if(e === "3"){
      status = "On Hold"
   }else if(e === "4"){
      status = ""
   }else{
      status = ""
   }

   return status
}

export const CreditCardNumberFormat = (num) => {
  return num.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ");
};

export const CheckResponse = (response) => {
   if(response.status === ApiResponseSuccess){
      return true
   }else if(response.status === ApiResponseStatusUnauthorized){
      window.location.href = "/login"
   }else{
      return false
   }
}

export const CheckUndefined = (x) => {
   if (typeof(x) === 'undefined') {
      return false
   }

   return true
}
